var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpless(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 10V5.59908C17.5 3.77414 17.5 2.86168 16.9106 2.3624C16.3212 1.86313 15.4204 2.01327 13.6187 2.31356L12.74 2.46001C11.3731 2.68782 10.6897 2.80172 10 2.80172C9.31031 2.80172 8.62688 2.68782 7.26002 2.46001L6.38133 2.31356C4.57961 2.01327 3.67875 1.86313 3.08938 2.3624C2.5 2.86168 2.5 3.77414 2.5 5.59908V10C2.5 14.5753 6.03247 16.7956 8.2488 17.7384C8.85001 17.9941 9.15062 18.122 10 18.122C10.8494 18.122 11.15 17.9941 11.7512 17.7384C13.9675 16.7956 17.5 14.5753 17.5 10Z",
    stroke: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41666 7.49999C5.65926 7.01449 6.31386 6.66666 7.08332 6.66666C7.85278 6.66666 8.50739 7.01449 8.74999 7.49999",
    stroke: "#fff",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 7.49999C11.4926 7.01449 12.1472 6.66666 12.9167 6.66666C13.6861 6.66666 14.3407 7.01449 14.5833 7.49999",
    stroke: "#fff",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08334 12.5C7.08334 12.5 7.95834 11.6667 10 11.6667C12.0417 11.6667 12.9167 12.5 12.9167 12.5",
    stroke: "#fff",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpless);
export default __webpack_public_path__ + "static/media/helpless.16b84978f7a312909fc3bb619c45941a.svg";
export { ForwardRef as ReactComponent };